import { render, staticRenderFns } from "./urd_calendar.vue?vue&type=template&id=b0feb508&scoped=true&"
import script from "./urd_calendar.vue?vue&type=script&lang=js&"
export * from "./urd_calendar.vue?vue&type=script&lang=js&"
import style0 from "./urd_calendar.vue?vue&type=style&index=0&id=b0feb508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0feb508",
  null
  
)

export default component.exports